module.exports = __webpack_public_path__ + "img/User-Icon.7e30eac5.svg";